import { useState, useEffect } from "react";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const useTicketsDashboardTable = ({ initialDate, finalDate, considerInternalChats, setIsLoading }) => {
  const [rows, setRows] = useState(0);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      const fetchClosedTickets = async() => {
        try {
          setIsLoading(true);
          const { data } = await api.get("/listTicketsTable", {
            params: { initialDate, finalDate, considerInternalChats },
          });
                  
          setRows(data);
        } catch (exception) {
          console.log("Use Tickets Dashboard Table Exception:", exception);
          toastError(exception);
        } finally {
          setIsLoading(false);
        }
      }
      
      fetchClosedTickets();
    }, 500);
    
    return () => clearTimeout(delayDebounceFn);
  }, [initialDate, finalDate, considerInternalChats, setIsLoading])
  
  return rows;
}

export default useTicketsDashboardTable;